import { IconButton, IconButtonProps, SxProps, Theme, useTheme } from '@mui/material';

import CloseIcon from './icons/CloseIcon';

export interface CloseButtonProps extends Omit<IconButtonProps, 'children'> {
  containerbackground?: 'light' | 'dark';
}

export function CloseButton({ containerbackground = 'light', sx, ...props }: CloseButtonProps) {
  const theme = useTheme();

  const lightBackgroundStyles: SxProps<Theme> = {
    backgroundColor: theme.palette.sandShade2.main,
    color: theme.palette.taiga.main,
    '&:hover': {
      backgroundColor: theme.palette.sandShade2.main,
      border: `1px solid ${theme.palette.taiga.main}`,
    },
  };

  const darkBackgroundStyles: SxProps<Theme> = {
    color: theme.palette.sand.main,
    border: `1px solid ${theme.palette.forestTint1.main}`,
    '&:hover': {
      border: `1px solid ${theme.palette.sand.main}`,
    },
  };

  const styles = containerbackground === 'light' ? lightBackgroundStyles : darkBackgroundStyles;

  return (
    <IconButton
      aria-label='close'
      {...props}
      sx={{
        width: '40px',
        height: '40px',
        borderRadius: 9999,
        transition: 'all .5s ease-in-out',
        ...styles,
        ...sx,
      }}
    >
      <CloseIcon sx={{ width: 20, height: 20 }} />
    </IconButton>
  );
}
